// A GP may only correct (edit) or cancel their OWN submissions — a review
// submitted by another GP requires manual intervention (GP Contract v3-2 CDM
// spec: "GPs may only correct or cancel their own submissions"). The BE enforces
// this; the FE mirrors it so the Edit / Cancel actions are disabled up front.

export const NOT_OWNER_MESSAGE =
  "Only the doctor who submitted this review can edit or cancel it.";

export const isOwnReview = ({ doctorId, doctorName, staffId, staffName }) => {
  if (doctorId != null && staffId != null) {
    return String(doctorId) === String(staffId);
  }

  if (doctorName && staffName) {
    return doctorName === staffName;
  }

  // Ownership cannot be determined (missing data) — don't block in the UI; the
  // BE still rejects an unauthorised correction/cancellation.
  return true;
};
